import React, { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useUserContext } from "../../../contexts/UserContext";
import { useContentfulContext } from "../../../contexts/ContentfulContext";
import { getProductFeedMeta } from "../../../utils/APIs";
import NewFeed from "./NewFeed";
import FeedEditor from "./FeedEditor";
import { DEFAULT_CONTENT, PRODUCT_FEEDS_FUNCTION_ID } from "./constants";
import { errorMessage } from "./helpers";

// Product Feeds function. From the functions catalogue it creates a feed; from
// Saved tasks (/functions/one-off-tasks/product_feeds/:saved_task_id) it edits
// one. A feed's saved task shares its id.
const ProductFeeds = ({ setShowBackNavigationArrow }) => {
    const { userData } = useUserContext();
    const { content } = useContentfulContext();
    const { saved_task_id: feedId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const [meta, setMeta] = useState(null);

    const UI_CONTENT = { ...DEFAULT_CONTENT, back_to_saved_tasks: content?.tasks?.back_cta_text2 || DEFAULT_CONTENT.back_to_saved_tasks, ...(content?.PRODUCT_FEEDS_CONTENT || {}) };
    const functionId = content?.tasks?.product_feeds?.id || PRODUCT_FEEDS_FUNCTION_ID;
    const auth = { token: userData?.token, organizationId: userData?.selectedOrganization?.org_token };

    // Option lists and defaults come from the server so they match the engine.
    useEffect(() => {
        if (!auth.token) return;
        getProductFeedMeta(auth)
            .then((result) => setMeta(result?.data))
            .catch((error) => toast.error(errorMessage(error)));
    }, [auth.token, auth.organizationId]);

    // Hide the page's back link while a feed is open; the editor has its own,
    // which asks before discarding unsaved changes.
    useEffect(() => {
        setShowBackNavigationArrow?.(!feedId);
        return () => setShowBackNavigationArrow?.(true);
    }, [feedId, setShowBackNavigationArrow]);

    const setTab = (tab) => setSearchParams(tab ? { tab } : {});

    // inline-size containment stops long unbroken content (URLs, JSON, wide
    // tables) from widening the page layout and squeezing the side navigation.
    return (
        <div className="w-full min-w-0 flex flex-col gap-4 [contain:inline-size]">
            {feedId ? (
                <FeedEditor
                    key={feedId}
                    feedId={feedId}
                    auth={auth}
                    meta={meta}
                    content={UI_CONTENT}
                    tab={searchParams.get("tab") || "sources"}
                    onTabChange={setTab}
                    onClose={() => navigate("/functions/saved-tasks")}
                />
            ) : (
                <NewFeed auth={auth} content={UI_CONTENT} onCreated={(id) => navigate(`/functions/one-off-tasks/${functionId}/${id}?tab=sources`)} />
            )}
        </div>
    );
};

export default ProductFeeds;
